module.exports = __webpack_public_path__ + "img/register-right-bg-second.8f023306.png";